export default "__VITE_ASSET__BG$YK9Xt__"